<vcl-modal id="modal-b" [modalTitle]="terms.title" [(showModal)]="modalShow" (modalButtonClick)="showModalEvent($event)" [buttonLabels]=" { primary: 'Descargar PDF'} " buttonAlignment="vertical">
  <p class="text_modal" [innerHtml]="terms.description"></p>
</vcl-modal>

<div id="header-account-info-creation" class="col-4 col-pr-12 col-sm-8 col-md-12 col-xl-12 col-lg-12 mb-2">
  <div class="message">
    <h1 class="title">
      ¡{{ userId.firstname }},
      <div *ngIf="product != 999 && !firmlyApproved">
        <span *ngIf="pco === 'PCO01', else titleGrayZone" [innerHtml]="product == 209  || product == 210 ?
        copyService.copies.account_info_creation.title_revolving : copyService.copies.account_info_creation.title_personal">
        </span>
      </div>
      <span *ngIf="firmlyApproved" [innerHtml]="product == 209  || product == 210 ?
      copyService.copies.account_info_creation.title_revolving : copyService.copies.account_info_creation.title_personal">
      </span>
      <span *ngIf="product == 999" [innerHtml]="copyService.copies.account_info_creation.title_loan">
      </span>
      <ng-template #titleGrayZone>
        <span [innerHtml]="(product == 209 && !firmlyApproved)  || product == 210 ?
                    copyService.copies.account_info_creation.title_revolving_grayzone :
                    copyService.copies.account_info_creation.title_personal_grayzone">
        </span>
      </ng-template>
    </h1>
  </div>
</div>
<div id="account-info-creation-container" class="col-4 col-pr-12 col-sm-8 col-md-12 col-xl-12 col-lg-12">
  <div class="container-card">
    <div class="detail_box">
      <div class="icon_box">
        <em class="{{ product == 209  || product == 210 ? 'icon-itaufonts_cartoes' : 'icon-itaufonts_credito'}}"></em>
        <strong class="description_box" *ngIf="pco === 'PCO01' && product != 999">
          {{product == 209  || product == 210 ? copyService.copies.account_info_creation.characteristics_quota : copyService.copies.account_info_creation.characteristics_personal}}
        </strong>
        <strong class="description_box" *ngIf="pco === 'PCO01' && product == 999">
          {{copyService.copies.account_info_creation.characteristics_loan}}
        </strong>
        <strong class="description_box" *ngIf="pco === 'PCO03'">
          {{product == 209  || product == 210 ? copyService.copies.account_info_creation.characteristics_quota_grayzone : copyService.copies.account_info_creation.characteristics_personal_grayzone}}
        </strong>
        <strong class="description_box" *ngIf="firmlyApproved">
          {{ product == 209 ? copyService.copies.account_info_creation.characteristics_quota : copyService.copies.account_info_creation.characteristics_personal }}
        </strong>
      </div>
      <div class="detail">
        <div class="case-id" *ngIf="pco == 'PCO01' && product == 209 || product == 210">
          <p><strong>{{  copyService.copies.account_info_creation.approved_quota }}</strong></p>
          <p class="subtitle_approved">${{ amountPco }}</p>
        </div>
        <div class="case-id" *ngIf="firmlyApproved && product == 209">
          <p><strong>{{  copyService.copies.account_info_creation.approved_quota }}</strong></p>
          <p class="subtitle_approved">${{ amountPco }}</p>
        </div>
        <div class="case-id" *ngIf="pco != 'PCO03' && product == 211 || product == 231 || product == 999">
          <p><strong>{{ product == 999 ? copyService.copies.account_info_creation.require_quota_loan : copyService.copies.account_info_creation.approved_quota_personal }}</strong></p>
          <p class="subtitle_approved">${{ amountPco }}</p>
        </div>
        <div class="case-id" *ngIf="pco == 'PCO03'  && product == 211">
          <p><strong>{{ copyService.copies.gray_zone_multi.valor }}</strong></p>
          <p class="subtitle_approved">${{ amountPco }}</p>
        </div>
        <div class="case-id">
          <p><strong>{{copyService.copies.account_info_creation.term}}</strong></p>
          <p class="subtitle">{{ this.termValue }}</p>
        </div>
        <div class="case-id" *ngIf="product == 211 || product == 231 && showRate">
          <p><strong>{{copyService.copies.account_info_creation.tax}}</strong></p>
          <p>{{ rateLiving }}</p>
        </div>
        <div class="case-id" *ngIf="product == 999 && showRate">
          <p><strong>{{copyService.copies.account_info_creation.tax}}</strong></p>
          <p>{{ rateLib }}</p>
          <br>
          <p class="info-text">
            {{copyService.copies.account_info_creation.tax_loan_1}}
          <br><br>
            {{copyService.copies.account_info_creation.tax_loan_2}}
          </p>
        </div>
        <div class="case-id" *ngIf="pco == 'PCO03'">
          <p><strong>{{ productClient ? copyService.copies.account_info_creation.solicitation_number : copyService.copies.account_info_creation.case_number }}</strong></p>
          <p class="subtitle">{{ solicitationId }}</p>
        </div>
      </div>
      <div *ngIf="product == 209  || product == 210">
        <div class="subtitle_current_rate">
          {{copyService.copies.account_info_creation.current_rate}}
        </div>
        <div class="mt-1" *ngIf="product != 209">
          <vcl-link [linkId]="'https://www.itau.co/tasasytarifas'" (click)="goToLink()" [label]="copyService.copies.account_info_creation.rates">
          </vcl-link>
        </div>
        <ul class="mt-3">
          <vcl-list>
            <li *ngFor="let option of revolvingBenefits" vclListSimple>
              <span id="iconCheck" class="icon icon-itaufonts_check">
              </span>
              <vcl-list-text>
                {{option}}
              </vcl-list-text>
            </li>
          </vcl-list>
        </ul>
      </div>
    </div>
    <div class="aditional-text gray_border py-4 px-0" *ngIf="product == 211 || product == 209 || product == 231  || product == 210">
      <p class="info-text" *ngIf="product == 211 || product == 231">
        {{copyService.copies.account_info_creation.tax_leyend_1}}
        <br><br>
        {{copyService.copies.account_info_creation.tax_leyend_2}}
        <br><br>
        {{copyService.copies.account_info_creation.tax_leyend_3}}
        <br><br>
      </p>

      <p class="info-account-selected" *ngIf="productClient">
        {{product === 211 || product == 231 ? copyService.copies.account_info_creation.account_selected : copyService.copies.account_info_creation.account_selected_revolving}} <strong>{{ accountNumber }}</strong>.
      </p>
    </div>

  </div>
</div>
<div *ngIf="!productClient && product != 999">
  <h2 class="title_1 mb-2" id="generalTitle">
    {{copyService.copies.account_info_creation.tittle_feature}}
  </h2>
</div>
<div id="account-info-creation-container" class="col-4 col-pr-12 col-sm-8 col-md-12 col-xl-12 col-lg-12">
  <div class="container-card">
    <div *ngIf="!productClient && product != 999">
      <div class="detail_box gray_border">
        <div class="icon_box">
          <em class="icon-itaufonts_conta_corrente"></em>
          <strong class="description_feature">
            Transacciones sin costo
          </strong>
        </div>
        <div class="detail">
          <div class="case-id" *ngFor="let transactional of transactionkit.detail">
            <p><strong>{{transactional.detail}}</strong></p>
            <p class="subtitle">{{ transactional.value }}</p>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="!productClient && product != 999">
      <div class="aditional-text gray_border">
        <h2><strong>{{copyService.copies.account_info_creation.usa_pagues_tittle}}</strong></h2>
        <p class="info-text">
          <span [innerHtml]="transactionkit.share[0].description"></span>
          <br><br>
              {{copyService.copies.account_info_creation.usa_pagues_sub2}}
            </p>
      </div>
    </div>
    <div *ngIf="product == 999">
      <div class="aditional-text gray_border">
        <p>
          {{copyService.copies.account_info_creation.loan_description}}
        </p>
        <br>
        <p *ngIf="check">
          {{copyService.copies.account_info_creation.loan_description_check}}
        </p>
        <p *ngIf="accountNumber !== '' && !check">
          {{copyService.copies.account_info_creation.loan_description_account}} <strong>{{ accountNumber }}</strong>.
        </p>
        <div class="gray_border">
          <div *ngIf="accountNumber === ''">
            <h1 class="title"> {{copyService.copies.account_info_creation.characteristics_aho}} </h1>
          </div>
          <div class="detail_box" *ngIf="accountNumber === ''">
            <div class="icon_box">
              <em class="icon-itaufonts_conta_corrente"></em>
              <strong class="description_feature"> {{copyService.copies.account_info_creation.transaction_cost}} </strong>
            </div>
            <div class="detail">
              <div class="case-id">
                <p>{{copyService.copies.account_info_creation.withdrawals_itau}}</p>
                <p class="subtitle"> {{copyService.copies.account_info_creation.unlimited}} </p>
              </div>
              <div class="case-id">
                <p>{{copyService.copies.account_info_creation.withdrawals}}</p>
                <p class="subtitle" *ngIf="!showCharacteristics">
                  {{monthly(6)}}
                </p>
                <p class="subtitle" *ngIf="showCharacteristics">
                  {{monthly(8)}}
                </p>
              </div>
              <div class="case-id">
                <p>{{copyService.copies.account_info_creation.transfers}}</p>
                <p class="subtitle"> {{ copyService.copies.account_info_creation.unlimited }} </p>
              </div>
              <div class="case-id">
                <p>{{copyService.copies.account_info_creation.manager_checks}}</p>
                <p class="subtitle" *ngIf="!showCharacteristics">
                  {{monthly(1)}}
                </p>
                <p class="subtitle" *ngIf="showCharacteristics">
                  {{monthly(2)}}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="aditional-text gray_border" *ngIf="accountNumber === ''">
          <h2><strong>{{copyService.copies.account_info_creation.usa_pagues_tittle}}</strong></h2>
            <p class="info-text">
              {{copyService.copies.account_info_creation.usa_pagues_sub1}}
            </p>
            <p class="info-text">
              {{copyService.copies.account_info_creation.usa_pagues_sub2}}
            </p>
        </div>
      </div>
    </div>
    <form id="formAcceptInsurability" [formGroup]="formGroup">
      <voxel-checkbox title="Terminos y condiciones" label="" name="checkTerms" id="checkTerms" [required]="true" (checkboxChange)="checkTerms($event)" formControlName="check_terms">
      </voxel-checkbox>
      <div class="containerLabelTerms">
        {{product == 209  || product == 210 ? copyService.copies.account_info_creation.terms_conditions : copyService.copies.account_info_creation.terms_conditions_personal}}
      </div>
    </form>
    <div class="terms-conditions">
      <vcl-link [linkId]="'backDocDeclarationLink'" (click)="showModalEvent($event)" [label]="copyService.copies.account_info_creation.link_terms_conditions">
      </vcl-link>
    </div>
  </div>
  <footer>
    <app-controls
      [hasPrevious]="false"
      [nextLabel]="copyService.copies.account_info_creation.next_button"
      [nextDisabled]="!acceptTerms"
      (only_previous)="sendBackButtonEvent()"
      (next)="checkBioCatch()"
    ></app-controls>
  </footer>
</div>
